import React from 'react';

const AdminUsers = () => {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Users Management</h1>
      <p>Manage your users here</p>
    </div>
  );
};

export default AdminUsers;